// extracted by mini-css-extract-plugin
export var indeterminate = "_1z-6";
export var md = "_1z-5";
export var semantic = "_1z-7";
export var sm = "_1z-4";
export var text = "_1z-8";
export var toggleControl = "_1z-0";
export var toggleInput = "_1z-1";
export var toggleSwitch = "_1z-2";
export var xs = "_1z-3";